"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.portal = exports.isSavingPagesOrder = exports.isPublishing = exports.isPortalLoading = exports.isDiscardingDraft = exports.isAssetLoading = exports.hasUnpublishedChanges = void 0;
var _reselect = require("reselect");
var _actionify = require("@mulesoft/actionify");
var _assets = require("../../utils/assets");
var assetsSelectors = _interopRequireWildcard(require("../assets/selectors"));
var _actionTypes = require("./actionTypes");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line import/no-extraneous-dependencies

var isAssetLoading = exports.isAssetLoading = function isAssetLoading(state) {
  return state.portals.ui.isAssetLoading;
};
var isPublishing = exports.isPublishing = function isPublishing(state) {
  return state.portals.ui.isPublishing;
};
var isPortalLoading = exports.isPortalLoading = (0, _reselect.createSelector)(function (state) {
  return !!state.portals.ui.isPortalLoading;
}, function (state) {
  return !!state.portals.ui.isPageLoading;
}, isAssetLoading, function ($isPortalLoading, $isPageLoading, $isAssetLoading) {
  return $isPortalLoading || $isPageLoading || $isAssetLoading;
});
var portal = exports.portal = (0, _reselect.createSelector)(assetsSelectors.version, function (state) {
  return state.portals.data;
}, function (state, props) {
  return (0, _assets.getGAKey)(props);
}, function (state, _ref) {
  var isDraft = _ref.isDraft;
  return isDraft;
}, function ($version, $portals, $gaKey, $isDraft) {
  return $portals && $version ? $portals["".concat($gaKey, "/").concat((0, _assets.getMinorVersion)($version)).concat($isDraft ? '/draft' : '')] : null;
});
var isDiscardingDraft = exports.isDiscardingDraft = (0, _actionify.createRequestLoadingSelector)(_actionTypes.DISCARD_PORTAL_DRAFT, function (requestParams, params) {
  return requestParams.organizationId === params.organizationId && requestParams.groupId === params.groupId && requestParams.assetId === params.assetId && requestParams.version === params.version;
});
var hasUnpublishedChanges = exports.hasUnpublishedChanges = (0, _reselect.createSelector)(portal, function ($portal) {
  return ($portal || {}).draftStatus !== 'PUBLISHED';
});
var isSavingPagesOrder = exports.isSavingPagesOrder = (0, _actionify.createRequestLoadingSelector)(_actionTypes.ORDER_PAGES);
//# sourceMappingURL=selectors.js.map